if($('footer#footer').length){
    $(document).on('click', '.custom-footer>div h4', function(){
        $(this).closest('.custom-footer>div').toggleClass('openIt')
    });
    $('.needHelp ul, .detailNeedHelp ul').prepend($('footer#footer .contact-box li span.mail').closest('li').clone());
    $('.needHelp ul, .detailNeedHelp ul').prepend($('footer#footer .contact-box li span.tel').closest('li').clone());

    $('footer#footer ul.helpLineContact').prepend($('footer#footer .contact-box li span.mail').closest('li').clone());
    $('footer#footer ul.helpLineContact').prepend($('footer#footer .contact-box li span.tel').closest('li').clone());
    $('footer#footer ul.superSocial').append($('footer#footer .contact-box li span.instagram').closest('li').clone());
    $('footer#footer ul.superSocial').append($('footer#footer .contact-box li span.facebook').closest('li').clone());
    if($('.in-index').length){
        //$('.homepage-box.welcome-wrapper').before($('footer#footer .blog'));
        $('.homepage-box.welcome-wrapper').before($('footer#footer .reviews'))
    }
    if($('.type-detail').length){
        $('.type-detail #tab-content #description').after($('footer#footer .reviews'));
    }
    if($('.id-29').length){
        $('#content-wrapper').after($('footer#footer .reviews'));
        $('.contactTop .left').append($('footer#footer .helpLine').clone());

    }
    
    $('footer#footer').before($('footer#footer .custom-footer__newsletter').append($('footer#footer .newsletterHeader')).wrapInner('<div class="container"></div>'));
    if($('.instagram-widget').length){
        $('footer#footer').before($('footer#footer .instagramLine'));
        $(".instagram-widget>a").each(function(){
            $(".instagramLine .igFeed").append('<div class="igPost"><a href="'+$(this).attr("href")+'" target="_blank" style="background-image: url('+$(this).find("img").attr("data-src")+')"></a></div>')
        });
    }
    $('#formNewsletterWidget input[type="email"]').attr('placeholder', 'Vaše e-mailová adresa');
     $('footer#footer').before($('footer#footer .customInfoEU'));
    

}